var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 4.50033C14.6666 3.76699 14.0666 3.16699 13.3333 3.16699H2.66659C1.93325 3.16699 1.33325 3.76699 1.33325 4.50033M14.6666 4.50033V12.5003C14.6666 13.2337 14.0666 13.8337 13.3333 13.8337H2.66659C1.93325 13.8337 1.33325 13.2337 1.33325 12.5003V4.50033M14.6666 4.50033L7.99992 9.16699L1.33325 4.50033",
    stroke: "#1D252B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.24d20077cef2ce9b0e6627e71fe19f8a.svg";
export { ForwardRef as ReactComponent };